module.exports = __webpack_public_path__ + "static/img/MN@2x.5423398d.jpg";